/* Grondyke · Main product buy box.
   Variant / plan / quantity / add-on state, gallery, sticky bar, and add-to-cart.
   Cart: posts a JSON items[] payload to cart/add.js (the main variant with its selling plan,
   plus the add-on as a second line item) and then reuses Eurus's own drawer pipeline
   (xCartHelper.reRenderSections + xMiniCart.openCart), exactly as Eurus's bundle builder does.
   Falls back to the native form submit when Alpine or the Eurus stores are unavailable. */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var fmt = format || (window.Eurus && window.Eurus.money_format) || '${{amount}}';
    var value = '';
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(fmt);
    var type = m ? m[1] : 'amount';
    var n = (Number(cents) || 0) / 100;
    function fixed(num, precision, thousands, decimal) {
      var parts = num.toFixed(precision).split('.');
      var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? int + decimal + parts[1] : int;
    }
    switch (type) {
      case 'amount_no_decimals': value = fixed(n, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = fixed(n, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fixed(n, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fixed(n, 2, "'", '.'); break;
      default: value = fixed(n, 2, ',', '.');
    }
    /* The shop money_format may be HTML ("<span class=money>$ {{amount}}</span>").
       Callers assign with textContent, so strip tags or the markup shows as text. */
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value).replace(/<[^>]*>/g, '').trim();
  }



  /* Line item properties.
     The form carries properties[...] inputs (the pre-order ship line is one), but this script
     intercepts submit and posts a JSON items[] payload, so anything not copied here is dropped on
     the floor. It was: pre-order lines reached Admin with no property on them at all. Read them
     off the form rather than naming them, so a new property only has to be added to the markup. */
  function readProperties(scope) {
    var out = null, els = scope.querySelectorAll('[name^="properties["]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.disabled) continue;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) continue;
      var m = /^properties\[(.+)\]$/.exec(el.getAttribute('name') || '');
      if (!m || el.value === '') continue;   /* Shopify drops empty properties anyway */
      out = out || {};
      out[m[1]] = el.value;
    }
    return out;
  }

  /* Shared cart helper: JSON items[] to cart/add.js, then Eurus's drawer re-render + open. */
  window.GkCart = window.GkCart || {
    formatMoney: formatMoney,
    available: function () {
      var A = window.Alpine;
      return !!(A && A.store && A.store('xCartHelper') && A.store('xMiniCart') && window.fetch && window.Shopify && window.Shopify.routes);
    },
    add: function (items, buttons, errorEl) {
      var A = window.Alpine, helper = A.store('xCartHelper'), mini = A.store('xMiniCart');
      var btns = buttons ? Array.prototype.slice.call(buttons) : [];
      btns.forEach(function (b) { b.classList.add('is-loading'); b.disabled = true; });
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      return helper.waitForCartUpdate().then(function () {
        window.updatingCart = true;
        return fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: items,
            sections: helper.getSectionsToRender().map(function (s) { return s.id; }),
            sections_url: window.location.pathname
          })
        });
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res.status && res.status >= 400) {
          if (errorEl) { errorEl.textContent = res.description || res.message || 'Could not add to cart.'; errorEl.hidden = false; }
          document.dispatchEvent(new CustomEvent('eurus:product:add-failed', { detail: { errorMessage: res.description } }));
          return false;
        }
        helper.reRenderSections(res.sections);
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) helper.currentItemCount = parseInt(bubble.innerHTML) || helper.currentItemCount;
        /* The PDP upsell popup, when the main buy form armed it, answers this one add instead
           of the drawer and opens the drawer itself once the shopper has chosen. consumeArmed
           is one-shot, so the quick-add bands that share this helper are untouched. */
        var gkUps = window.GkUpsell;
        if (gkUps && gkUps.consumeArmed()) {
          gkUps.show(res, items);
        } else {
          var noti = A.store('xCartNoti');
          if (noti && noti.enable && res.items && res.items.length === 1) {
            noti.setItem(res.items[0]);
          } else {
            mini.openCart();
          }
        }
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
        document.dispatchEvent(new CustomEvent('eurus:cart:redirect'));
        document.dispatchEvent(new CustomEvent('eurus:product:added', { detail: { product: res.items ? res.items[0] : res } }));
        return true;
      }).catch(function (err) {
        if (errorEl) { errorEl.textContent = 'Could not add to cart. Please try again.'; errorEl.hidden = false; }
        document.dispatchEvent(new CustomEvent('eurus:product:add-failed', { detail: { errorMessage: err } }));
        return false;
      }).then(function (ok) {
        window.updatingCart = false;
        btns.forEach(function (b) { b.classList.remove('is-loading'); b.disabled = false; });
        return ok;
      });
    }
  };

  /* Quick-add forms (loofah band): a plain product form upgraded to the drawer when possible. */
  if (!window.gkQuickAddBound) {
    window.gkQuickAddBound = true;
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.hasAttribute || !f.hasAttribute('data-gk-quickadd')) return;
      if (!window.GkCart.available()) return;
      e.preventDefault();
      var id = f.querySelector('[name="id"]'), q = f.querySelector('[name="quantity"]');
      if (!id) return;
      var qItem = { id: Number(id.value), quantity: Number(q && q.value) || 1 };
      var qProps = readProperties(f);
      if (qProps) qItem.properties = qProps;
      window.GkCart.add([qItem], f.querySelectorAll('[type="submit"]'), f.querySelector('[data-gk-error]'));
    });
  }

  function init(root) {
    var form = root.querySelector('[data-gk-form]');
    if (!form) return;
    var idInput = form.querySelector('[data-gk-id]');
    var planInput = form.querySelector('[data-gk-plan-input]');
    var addonIdInput = form.querySelector('[data-gk-addon-id]');
    var addonQtyInput = form.querySelector('[data-gk-addon-qty]');
    var qtyInput = form.querySelector('[data-gk-qty-input]');
    var variants = Array.prototype.slice.call(form.querySelectorAll('[data-gk-variant]'));
    var packs = Array.prototype.slice.call(form.querySelectorAll('[data-gk-pack]'));
    var modes = root.querySelector('[data-gk-modes]');
    var addon = form.querySelector('[data-gk-addon]');
    var addonBtn = form.querySelector('[data-gk-addon-btn]');
    var sticky = root.querySelector('[data-gk-sticky]');
    var errorEl = form.querySelector('[data-gk-error]');
    var footnote = form.querySelector('[data-gk-footnote]');
    var subLabel = root.querySelector('[data-gk-sub-label]');
    var subPrice = root.querySelector('[data-gk-sub-price]');
    var subWas = root.querySelector('[data-gk-sub-was]');
    var subNote = root.querySelector('[data-gk-sub-note]');
    var subDetail = root.querySelector('[data-gk-sub-detail]');
    var oncePrice = root.querySelector('[data-gk-once-price]');
    var subCard = root.querySelector('[data-gk-mode="sub"]');
    var onceCard = root.querySelector('[data-gk-mode="once"]');
    var strings = {
      cta: root.getAttribute('data-cta-label'),
      ctaSub: root.getAttribute('data-cta-sub-label'),
      foot: root.getAttribute('data-footnote'),
      footSub: root.getAttribute('data-footnote-sub'),
      subLabel: root.getAttribute('data-sub-label') || '',
      soldOut: root.getAttribute('data-sold-out-label'),
      addonAdd: root.getAttribute('data-addon-add'),
      addonAdded: root.getAttribute('data-addon-added'),
      onceMeta: root.getAttribute('data-once-meta')
    };
    var productUrl = root.getAttribute('data-product-url');

    var state = { variant: null, mode: 'once', plan: null, qty: 1, addon: false };

    function variantData(id) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].getAttribute('data-variant-id') === String(id)) return variants[i];
      }
      return variants[0];
    }
    function currentPlans() {
      if (!state.variant) return null;
      return root.querySelector('[data-gk-plans][data-variant-id="' + state.variant.getAttribute('data-variant-id') + '"]');
    }
    function selectedPlanInput() {
      var wrap = currentPlans();
      if (!wrap) return null;
      return wrap.querySelector('[data-gk-plan]:checked') || wrap.querySelector('[data-gk-plan]');
    }

    function togglePerVariant(id) {
      var nodes = root.querySelectorAll('.gk-pv[data-variant-id]');
      for (var i = 0; i < nodes.length; i++) {
        var on = nodes[i].getAttribute('data-variant-id') === String(id);
        if (on) nodes[i].removeAttribute('hidden'); else nodes[i].setAttribute('hidden', '');
      }
    }

    function setVariant(id, pushUrl) {
      state.variant = variantData(id);
      var vid = state.variant.getAttribute('data-variant-id');
      idInput.value = vid;
      packs.forEach(function (p) { p.classList.toggle('is-selected', p.getAttribute('data-variant-id') === vid); });
      togglePerVariant(vid);
      // Purchase mode always resets to one-time on a supply change (content-mapping §11).
      setMode('once');
      var hasSub = state.variant.getAttribute('data-sub') === '1';
      if (modes) {
        if (subCard) subCard.hidden = !hasSub;
        if (subNote) subNote.hidden = hasSub;
        var price = Number(state.variant.getAttribute('data-price')) || 0;
        if (oncePrice) oncePrice.textContent = formatMoney(price);
        if (subWas) subWas.textContent = formatMoney(price);
        var plan = selectedPlanInput();
        if (plan) applyPlanLabels(plan);
      }
      if (pushUrl && productUrl && window.history && window.history.replaceState) {
        var url = productUrl + (productUrl.indexOf('?') > -1 ? '&' : '?') + 'variant=' + vid;
        window.history.replaceState({}, '', url);
      }
      updateTotals();
    }

    function applyPlanLabels(planEl) {
      var pct = planEl.getAttribute('data-pct') || '0';
      if (subLabel) subLabel.textContent = strings.subLabel.replace('[pct]', pct);
      if (subPrice) subPrice.textContent = formatMoney(planEl.getAttribute('data-price'));
      var wrap = currentPlans();
      if (wrap) {
        var labels = wrap.querySelectorAll('.gk-plan');
        for (var i = 0; i < labels.length; i++) {
          labels[i].classList.toggle('is-selected', labels[i].contains(planEl));
        }
      }
    }

    function setMode(mode) {
      var hasSub = state.variant && state.variant.getAttribute('data-sub') === '1';
      if (mode === 'sub' && !hasSub) mode = 'once';
      state.mode = mode;
      if (onceCard) onceCard.classList.toggle('is-selected', mode === 'once');
      if (subCard) subCard.classList.toggle('is-selected', mode === 'sub');
      if (subDetail) subDetail.hidden = mode !== 'sub';
      var inputs = root.querySelectorAll('[data-gk-mode-input]');
      for (var i = 0; i < inputs.length; i++) inputs[i].checked = inputs[i].value === mode;
      if (mode === 'sub') {
        var plan = selectedPlanInput();
        if (plan) {
          plan.checked = true;
          applyPlanLabels(plan);
          planInput.value = plan.getAttribute('data-plan-id');
          planInput.disabled = false;
          state.plan = plan;
        }
      } else {
        planInput.value = '';
        planInput.disabled = true;
        state.plan = null;
      }
      updateTotals();
    }

    function updateTotals() {
      if (!state.variant) return;
      var available = state.variant.getAttribute('data-available') === 'true';
      var unit = Number(state.variant.getAttribute('data-price')) || 0;
      if (state.mode === 'sub' && state.plan) unit = Number(state.plan.getAttribute('data-price')) || unit;
      var total = unit * state.qty;
      if (state.addon && addon) total += Number(addon.getAttribute('data-price')) || 0;
      var money = formatMoney(total);
      var totals = root.querySelectorAll('[data-gk-total]');
      for (var i = 0; i < totals.length; i++) totals[i].textContent = money;
      var ctas = root.querySelectorAll('[data-gk-cta-label]');
      var label = !available ? strings.soldOut : (state.mode === 'sub' ? strings.ctaSub : strings.cta);
      for (var j = 0; j < ctas.length; j++) ctas[j].textContent = label;
      var submits = root.querySelectorAll('[data-gk-submit]');
      for (var k = 0; k < submits.length; k++) {
        submits[k].disabled = !available;
        submits[k].setAttribute('data-total', money);
      }
      if (footnote) {
        if (state.mode === 'sub' && state.plan) {
          footnote.textContent = (strings.footSub || '').replace('[interval]', state.plan.getAttribute('data-label') || '');
        } else {
          footnote.textContent = strings.foot || '';
        }
      }
      var meta = root.querySelector('[data-gk-sticky-meta]');
      if (meta) {
        // The kicker is the descriptor Liquid put in front of the variant label. Rebuilding the
        // meta here used to drop it, which left single-variant products showing only the mode.
        // A mixed pack states its contents here instead of its variant, which is what the design
        // asks for and what Liquid rendered. Keep that line and only add what the shopper has
        // since changed: the add-on, and the plan when they have switched to a subscription.
        var facts = meta.getAttribute('data-gk-sticky-facts');
        var parts = facts
          ? [facts]
          : [meta.getAttribute('data-gk-sticky-kicker') || '', state.variant.getAttribute('data-label')];
        if (state.addon && addon) parts.push('+ ' + (addon.getAttribute('data-title') || ''));
        if (state.mode === 'sub' && state.plan) parts.push(state.plan.getAttribute('data-name') || '');
        else if (!facts) parts.push(strings.onceMeta || '');
        meta.textContent = parts.filter(Boolean).join(' · ');
      }
    }

    // Events
    variants.forEach(function (v) {
      v.addEventListener('change', function () { if (v.checked || v.type === 'hidden') setVariant(v.getAttribute('data-variant-id'), true); });
    });
    var modeInputs = root.querySelectorAll('[data-gk-mode-input]');
    for (var m = 0; m < modeInputs.length; m++) {
      modeInputs[m].addEventListener('change', function (e) { setMode(e.target.value); });
    }
    var planInputs = root.querySelectorAll('[data-gk-plan]');
    for (var p = 0; p < planInputs.length; p++) {
      planInputs[p].addEventListener('change', function (e) {
        state.plan = e.target;
        applyPlanLabels(e.target);
        setMode('sub');
      });
    }
    if (addonBtn && addon) {
      addonBtn.addEventListener('click', function () {
        state.addon = !state.addon;
        addonBtn.setAttribute('aria-pressed', state.addon ? 'true' : 'false');
        addonBtn.textContent = state.addon ? strings.addonAdded : strings.addonAdd;
        if (addonIdInput) addonIdInput.disabled = !state.addon;
        if (addonQtyInput) addonQtyInput.disabled = !state.addon;
        updateTotals();
      });
    }
    var qtyWrap = form.querySelector('[data-gk-qty]');
    if (qtyWrap && qtyInput) {
      function setQty(n) {
        n = Math.max(1, Math.min(Number(qtyInput.max) || 20, Math.round(Number(n) || 1)));
        qtyInput.value = n;
        state.qty = n;
        updateTotals();
      }
      qtyWrap.querySelector('[data-gk-qty-minus]').addEventListener('click', function () { setQty(state.qty - 1); });
      qtyWrap.querySelector('[data-gk-qty-plus]').addEventListener('click', function () { setQty(state.qty + 1); });
      qtyInput.addEventListener('change', function () { setQty(qtyInput.value); });
    }

    // Submit through Eurus's cart pipeline when it is present.
    form.addEventListener('submit', function (e) {
      if (!window.GkCart.available()) return; // native submit
      e.preventDefault();
      if (!state.variant || state.variant.getAttribute('data-available') !== 'true') return;
      var items = [];
      var main = { id: Number(idInput.value), quantity: state.qty };
      if (state.mode === 'sub' && state.plan) main.selling_plan = Number(state.plan.getAttribute('data-plan-id'));
      /* The add-on is a different product, so the properties belong to the main line only. */
      var mainProps = readProperties(form);
      if (mainProps) main.properties = mainProps;
      items.push(main);
      if (state.addon && addonIdInput) items.push({ id: Number(addonIdInput.value), quantity: 1 });
      var submits = root.querySelectorAll('[data-gk-submit]');
      /* Arm the upsell popup for this add only. No-op when the section did not render one. */
      if (window.GkUpsell) window.GkUpsell.arm();
      window.GkCart.add(items, submits, errorEl);
    });

    // Tabs
    var toggles = root.querySelectorAll('[data-gk-tab-toggle]');
    for (var t = 0; t < toggles.length; t++) {
      toggles[t].addEventListener('click', function (e) {
        var btn = e.currentTarget;
        var tab = btn.closest('.gk-tab');
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        var open = !tab.classList.contains('is-open');
        tab.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (panel) panel.hidden = !open;
      });
    }

    // Gallery
    var gallery = root.querySelector('[data-gk-gallery]');
    if (gallery) {
      var track = gallery.querySelector('[data-gk-track]');
      var slides = track.querySelectorAll('[data-gk-slide]');
      var dots = gallery.querySelectorAll('.gk-gallery__dot');
      var thumbs = gallery.querySelectorAll('.gk-gallery__thumb');
      function setActive(i) {
        for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === i);
        for (var th = 0; th < thumbs.length; th++) thumbs[th].classList.toggle('is-active', th === i);
      }
      function goTo(i) {
        if (!slides[i]) return;
        track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        setActive(i);
      }
      for (var th = 0; th < thumbs.length; th++) {
        thumbs[th].addEventListener('click', function (e) { goTo(Number(e.currentTarget.getAttribute('data-index'))); });
      }
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = window.requestAnimationFrame(function () {
          raf = null;
          var w = track.clientWidth || 1;
          setActive(Math.round(track.scrollLeft / w));
        });
      });
    }

    // Sticky bar: shows once the main CTA has scrolled out of view above the fold.
    var mainCta = form.querySelector('.gk-cta');
    if (sticky && mainCta && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var en = entries[0];
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('gk-sticky-open', show);
      }, { threshold: 0 });
      io.observe(mainCta);
    }

    // Initial state from the checked radio (or the ?variant= the page rendered with).
    var initial = form.querySelector('[data-gk-variant]:checked') || variants[0];
    if (initial) setVariant(initial.getAttribute('data-variant-id'), false);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-gk-pdp]');
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i].hasAttribute('data-gk-ready')) { roots[i].setAttribute('data-gk-ready', ''); init(roots[i]); }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
